import CustomerDetails from './CustomerDetails'
import InvoiceLines from './InvoiceLines'
import InvoiceInfo from './InvoiceInfo'
import withInvoice from 'hocs/WithInvoice'
import { Invoice } from 'types'
import './InvoiceShow.css'

interface InvoiceShowProps {
  invoice: Invoice
}

const InvoiceShow = ({ invoice }: InvoiceShowProps) => {
  return (
    <div className="invoice-show-content">
      <div className="mb-4">
        <InvoiceInfo invoice={invoice} />
      </div>
      <div className="mb-4">
        <CustomerDetails customer={invoice?.customer} />
      </div>
      <InvoiceLines invoice={invoice} />
    </div>
  )
}

export default withInvoice(InvoiceShow)
